import { z } from 'zod'

export const FormComboProductSchema = z.object({
  cod_produto_combo: z.string().optional(),
  imagem_path: z.string().optional(),
  produto: z.string().optional(),
  produto_nome: z.string().min(1, 'Produto obrigatório'),
  vlr_produto: z.string().min(1, 'Valor obrigatório'),
  qtde_produto: z.string().min(1, 'Quantidade obrigatória'),
})

export type FormComboProduct = z.infer<typeof FormComboProductSchema>
